export default function CarFridge(props: any) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M26.4839 27.42H5.5195C4.68061 27.42 4 26.7394 4 25.9005V4.65915C4 3.82026 4.68061 3.13965 5.5195 3.13965H26.4839C27.3228 3.13965 28.0034 3.82026 28.0034 4.65915V25.9005C27.9994 26.7394 27.3228 27.42 26.4839 27.42Z"
                stroke="#757575"
                strokeWidth="1.10232"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.87049 27.4197V28.86H5.96094V27.4197"
                stroke="#757575"
                strokeWidth="1.10232"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.2337 27.4197V28.86H22.3281V27.4197"
                stroke="#757575"
                strokeWidth="1.10232"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M4 5.6604H28.0034" stroke="#757575" strokeWidth="1.10232" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M4 8.49364H9.06105C9.93555 8.49364 10.6478 7.78533 10.6478 6.90687V5.6604"
                stroke="#757575"
                strokeWidth="1.10232"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
